import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { KeyValues3, KeyValues10, LocalService, Payment, PaymentGatewayOrderStatus, StatusWithId, RazorPayCustomerRequest, RazorPayCustomerResponse, CallbackType, QrType, KeyValues5 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class PaymentManagementService {
  private controllerName = service_controllers_methods.payment.controller;
  private methods = service_controllers_methods.payment.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  getOrderId(payment: Payment, currency?: string, cutomerDetails?: KeyValues5): Observable<KeyValues10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: currency } as KeyValues3,
      cutomerDetails: cutomerDetails,
      pay: payment
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetOrderId, body);
  }

  getPaymentGatewayOrderStatus(orderId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: orderId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPaymentGatewayOrderStatus, body, false);
  }

  updatePaymentGatewayResponse(callbackType: CallbackType, processId: string, paymentGatewayOrderStatus: PaymentGatewayOrderStatus, businessId: string, countryCode?: string, referenceId?: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: processId, v2: paymentGatewayOrderStatus.toString(), v3: referenceId, v4: countryCode ?? this.localService.getLoginAsCountryCode(), v5: callbackType.toString(), v6: businessId } as KeyValues10
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdatePaymentGatewayResponse, body);
  }

  savePaymentGatewayCustomer(request: RazorPayCustomerRequest): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      request: request
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePaymentGatewayCustomer, body);
  }

  getPaymentGatewayCustomer(businessId: string, isLoadDefaultDetailsIfDataNotAvailable: boolean = false): Observable<RazorPayCustomerResponse> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { isSelected: isLoadDefaultDetailsIfDataNotAvailable, v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPaymentGatewayCustomer, body);
  }

  getPaymentQrType(businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPaymentQrType, body);
  }

  savePaymentQrType(businessId: string, qrType: QrType): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: qrType } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePaymentQrType, body);
  }

  SavePaymentGatewayCustomerFundAccountExternal(paymentGatewayCustomerId: string, request: RazorPayCustomerRequest): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: paymentGatewayCustomerId } as KeyValues3,
      request: request
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePaymentGatewayCustomerFundAccountExternal, body);
  }
}
